import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

import MaterialButton from './MaterialButton'

const TeacherResourceKitSpanish = ({ standard }) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Teacher Resource Kit (Spanish)" }) {
				title
				image {
					gatsbyImageData(placeholder: BLURRED)
				}
				description {
					description
				}
			}
		}
	`)

	const title = data.contentfulModal.title
	const description = data.contentfulModal.description.description
	const image = standard === 'CCSS' ? data.contentfulModal.image[0].gatsbyImageData : data.contentfulModal.image[1].gatsbyImageData

	return (
		<React.Fragment>
			<MaterialButton onClick={handleShow} image={image} title={title} />
			<Modal title={title} isOpen={show} handleClose={handleClose} wide>
				<Row>
					<Col>
						<p className="text-slate-400 text-lg">{description}</p>
					</Col>
					<Col>
						<GatsbyImage image={image} alt={title} />
					</Col>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

TeacherResourceKitSpanish.defaultProps = {
	standard: 'CCSS'
}

export default TeacherResourceKitSpanish
